<div>
    <video #video width="500" height="450" autoplay muted></video>
    <canvas #canvas width="420" height="400"></canvas>
    <button (click)="capture()">Capture</button>
    <a #downloadLink *ngIf="faceDictated">Save Image</a>
    <p>{{message}}</p>
</div>
